<template>
  <div class="address-input">
    <ValidationObserver v-slot="{ errors }" name="Adresse">
      <div class="vx-row">
        <TextInput
          :value="internalValue.street"
          class="vx-col w-full mt-4"
          label="Straße und Hausnummer"
          :placeholder="placeholder"
          :name="`${name}[street]`"
          @input="e => updateValue('street', e)"
        />
        <TextInput
          :value="internalValue.zip"
          class="vx-col w-full mt-4 lg:w-2/12"
          label="PLZ"
          :placeholder="placeholder"
          :name="`${name}[zip]${required ? '*' : ''}`"
          :required="required"
          :validation-rules="required ? 'required' : ''"
          @input="e => updateValue('zip', e)"
        />
        <TextInput
          :value="internalValue.city"
          class="vx-col w-full mt-4 lg:w-4/12"
          label="Ort"
          :placeholder="placeholder"
          :name="`${name}[city]${required ? '*' : ''}`"
          :validation-rules="required ? 'required' : ''"
          :required="required"
          @input="e => updateValue('city', e)"
        />
        <SelectInput
          :value="internalValue.country"
          class="vx-col w-full mt-4 lg:w-6/12"
          label="Land"
          type="select"
          :name="`${name}[country]${required ? '*' : ''}`"
          :required="required"
          :options="Countries"
          @input="e => updateValue('country', e)"
        />
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>

      <div
        v-if="
          (streetNotRequired || internalValue.street) &&
            internalValue.city &&
            internalValue.zip &&
            !internalValue.lat &&
            !showLoader
        "
        class="mt-3"
      >
        <span class="text-warning text-sm">
          Für die Adresse konnten keine Koordinaten ermittelt werden. Dadurch
          ist es nicht möglich die Adresse über die Standortsuche zu finden.
        </span>
        <vs-button class="mt-2" @click="updateLatLng"
          >Erneut versuchen</vs-button
        >
      </div>

      <vs-progress v-if="showLoader" indeterminate color="primary"
        >primary</vs-progress
      >
    </ValidationObserver>
  </div>
</template>

<script>
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";
import Countries from "@/data/other/Countries";
import axios from "axios";

export default {
  components: {
    SelectInput,
    TextInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        street: null,
        city: null,
        zip: null,
        country: 36,
        lat: null,
        lng: null
      })
    },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    label: { type: String, default: null },
    streetNotRequired: { type: Boolean, default: false },
    placeholder: { type: String, default: null },
    name: { type: String, required: true },
    required: { type: Boolean, default: false }
  },
  data: () => ({
    Countries,
    geocodeTimeout: null,
    showLoader: false
  }),
  beforeRouteLeave() {
    this.$vs;
  },
  computed: {
    internalValue: {
      get() {
        return (
          this.value || {
            street: null,
            city: null,
            zip: null,
            country: 36,
            lat: null,
            lng: null
          }
        );
      },
      set(value) {
        if (
          (this.streetNotRequired || value.street) &&
          value.city &&
          value.zip &&
          value.country
        ) {
          this.showLoader = true;
          value = Object.assign(value, {
            lat: null,
            lng: null
          });
          clearTimeout(this.geocodeTimeout);
          this.geocodeTimeout = setTimeout(() => {
            this.updateLatLng(value);
          }, 5000);
        } else if (!this.geocodeTimeout) {
          this.$emit("input", value);
        }
      }
    }
  },
  methods: {
    updateValue(field, value) {
      this.internalValue = Object.assign(this.internalValue, {
        [field]: value
      });
    },
    updateLatLng(value = null) {
      if (!value || "isTrusted" in value) {
        value = this.internalValue;
      }

      const street = value.street ? `${value.street}, ` : "";

      let country = Countries.find(el => el.code === value.country);
      if (country) {
        country = country.label;
      } else {
        country = "Deutschland";
      }

      axios
        .get("https://maps.googleapis.com/maps/api/geocode/json", {
          params: {
            address: `${street}${value.zip} ${value.city}, ${country}`,
            key: process.env.VUE_APP_MAPS_API_KEY
          }
        })
        .then(({ data }) => {
          if (data.results.length) {
            const addrInfo = data.results[0];

            value = Object.assign(value, {
              lat: addrInfo.geometry.location.lat,
              lng: addrInfo.geometry.location.lng
            });
          } else {
            value = Object.assign(value, {
              lat: null,
              lng: null
            });
          }

          this.$emit("input", value);
          this.showLoader = false;
        });
    }
  }
};
</script>
